<button [buttonStyle]
        class="w-12 p-r-0-s p-l-0-s"
        [class._is-disabled]="isButtonDisabled"
        [status]="status"
        (click)="submit()"
        cy-basketAddButton>
    {{ buttonCopy }}
</button>

<result class="block"
        [status]="status"></result>

@if (warning) {
<p class="p1 col-2 m-t-2">
    {{ warning }}
</p>
}